// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__aTvU1","label":"dropdown-option_label__Wim1K","center":"dropdown-option_center__HhnV6","count":"dropdown-option_count__umMvU"};